import { keyframes, styled } from '@withjoy/joykit';

// Code taken from https://codepen.io/nikkunikku/pen/mdGRbxW and converted to Styled Components using ChatGPT

const fade = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.25;
  }
`;

export const SpinnerContainer = styled.div`
  position: relative;
  width: 54px;
  height: 54px;
  padding: 10px;
`;

export const SpinnerBar = styled.div`
  width: 6%;
  height: 16%;
  background: ${props => props.theme.colors.brandPurple4};
  position: absolute;
  left: 49%;
  top: 43%;
  opacity: 0;
  border-radius: 50px;
  animation: ${fade} 1s linear infinite;

  &:nth-child(1) {
    transform: rotate(0deg) translate(0, -130%);
    animation-delay: 0s;
  }

  &:nth-child(2) {
    transform: rotate(30deg) translate(0, -130%);
    animation-delay: -0.9167s;
  }

  &:nth-child(3) {
    transform: rotate(60deg) translate(0, -130%);
    animation-delay: -0.833s;
  }

  &:nth-child(4) {
    transform: rotate(90deg) translate(0, -130%);
    animation-delay: -0.7497s;
  }

  &:nth-child(5) {
    transform: rotate(120deg) translate(0, -130%);
    animation-delay: -0.667s;
  }

  &:nth-child(6) {
    transform: rotate(150deg) translate(0, -130%);
    animation-delay: -0.5837s;
  }

  &:nth-child(7) {
    transform: rotate(180deg) translate(0, -130%);
    animation-delay: -0.5s;
  }

  &:nth-child(8) {
    transform: rotate(210deg) translate(0, -130%);
    animation-delay: -0.4167s;
  }

  &:nth-child(9) {
    transform: rotate(240deg) translate(0, -130%);
    animation-delay: -0.333s;
  }

  &:nth-child(10) {
    transform: rotate(270deg) translate(0, -130%);
    animation-delay: -0.2497s;
  }

  &:nth-child(11) {
    transform: rotate(300deg) translate(0, -130%);
    animation-delay: -0.167s;
  }

  &:nth-child(12) {
    transform: rotate(330deg) translate(0, -130%);
    animation-delay: -0.0833s;
  }
`;
